import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import type { PricingEstimationService } from '../../types';
import { SERVICES } from '../utils/estimateDisplay';
import { isDateOption } from '../utils/weddingDate';
import type { DateOption } from '../utils/weddingDate';
import { PRICING_DETAILS_PRODUCT_AREA } from './trackingConstants';

type TrackEstimateUserInput = PricingEstimationService[] | DateOption | string;

const getUserInput = (dateOption: DateOption): string => {
	if (dateOption === 'specificDate') return 'yes - specific date';
	return 'yes - approximate date';
};

const getServiceLabel = (service: PricingEstimationService): string => {
	const config = SERVICES.find(({ key }) => key === service);
	return config ? config.value.toLowerCase() : service;
};

const getUserInputValue = (
	userInput: TrackEstimateUserInput,
): string | string[] => {
	if (Array.isArray(userInput)) return userInput.map(getServiceLabel);
	if (typeof userInput === 'string' && isDateOption(userInput))
		return getUserInput(userInput);
	return userInput;
};

export const useTrackEstimateStepNext = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(decisionAreaValue: string, userInput: TrackEstimateUserInput) => {
			track({
				event: AnalyticsConstants.BUTTON_CLICKED,
				properties: {
					product_area: PRICING_DETAILS_PRODUCT_AREA,
					button_action: 'Next',
					location: 'estimate request flow',
					decision_area: decisionAreaValue,
					user_input: getUserInputValue(userInput),
				},
			});
		},
		[track],
	);
};
